import { render, staticRenderFns } from "./NewROContainer.vue?vue&type=template&id=813497ee"
import script from "./NewROContainer.vue?vue&type=script&lang=ts"
export * from "./NewROContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports